import { render, staticRenderFns } from "./totalCarbonReduction.vue?vue&type=template&id=2fa73423&scoped=true&"
import script from "./totalCarbonReduction.vue?vue&type=script&lang=js&"
export * from "./totalCarbonReduction.vue?vue&type=script&lang=js&"
import style0 from "./totalCarbonReduction.vue?vue&type=style&index=0&id=2fa73423&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa73423",
  null
  
)

export default component.exports